import React from "react";
import "../styles/changeLog.scss";
import { format } from "date-fns";

export default function ChangeLog({ changeLog }) {
  if (changeLog?.length === 0) {
    return null;
  }

  return (
    <div className="change-log-container">
      <h3 className="change-log-title"> Change Log</h3>
      <ChangeLogHeader />
      {changeLog.reverse().map((changeLogItem, index) => (
        <ChangeLogItem
          key={`chnageLogItem-${index}`}
          changeLogItem={changeLogItem}
        />
      ))}
    </div>
  );
}

function ChangeLogHeader() {
  return (
    <div className="change-log-row change-log-header">
      <span> Date & Time</span>
      <span> Action</span>
      <span> Action Performer</span>
    </div>
  );
}

function ChangeLogItem({ changeLogItem }) {
  return (
    <div className="change-log-row change-log-item">
      <span>{format(new Date(changeLogItem.date), "dd MMM yyyy, h:mm a")}</span>
      <span> {changeLogItem.action}</span>
      <span>
        {`${changeLogItem.actionPerformer.userName} (${changeLogItem.actionPerformer.userType})`}
      </span>
    </div>
  );
}
